export default __webpack_public_path__ + "static/media/gustavo-varalda-1.54920f7b.webp";